import { render, staticRenderFns } from "./VehicleSidebar.vue?vue&type=template&id=4ad9ae38"
import script from "./VehicleSidebar.vue?vue&type=script&lang=js"
export * from "./VehicleSidebar.vue?vue&type=script&lang=js"
import style0 from "./VehicleSidebar.vue?vue&type=style&index=0&id=4ad9ae38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports